module.exports = "/_next/static/images/nf-9c35f8b0f713f79b77a537b430129ec0.svg";